import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  data: [],
  error: null,
  loading: false,
  item: null,
  exportStatus: { loading: false, error: null },
}

const itemSlice = createSlice({
  name: "item",
  initialState,
  reducers: {
    setData(state, action) {
      state.data = action.payload
    },
    setError(state, action) {
      state.error = action.payload
    },
    setLoading(state, action) {
      state.loading = action.payload
    },
    setItem(state, action) {
      state.item = action.payload
    },
    setExportStatus(state, action) {
      state.exportStatus = {
        loading: action.payload.loading,
        error: action.payload.error,
      }
    },
    resetState(state) {
      state.data = []
      state.error = null
      state.loading = false
      state.item = null
      state.exportStatus = { loading: false, error: null }
    },
  },
})

export const itemAction = itemSlice.actions

export default itemSlice
